import useHistorySideEffect from 'app/components/router/useHistorySideEffect';
import { LocationDescriptorObject } from 'app/services/history';
import { isUrlOffAppSite } from 'app/utils/isUrlOffAppSite';
import { parseUrlLoose } from 'app/utils/LooseURL';
import { getFullUrl } from 'app/utils/routes';
import { parse, StringifiableRecord, stringify } from 'query-string';

interface IProps {
  to: LocationDescriptorObject | string;
  withRedirectTo?: boolean;
  query?: StringifiableRecord;
  method?: 'smartPush' | 'smartReplace' | 'push' | 'replace';
  shouldRedirect?: boolean;
}

export function useRedirect({
  to,
  withRedirectTo,
  query,
  method = 'smartReplace',
  shouldRedirect = true,
}: IProps) {
  const isOffApp = isUrlOffAppSite(typeof to === 'string' ? to : getFullUrl(to));
  if (isOffApp && withRedirectTo) {
    throw new Error('Setting a redirect to param on an offsite link is probably not intended.');
  }

  useHistorySideEffect(history => {
    if (!shouldRedirect) {
      return;
    }

    if (query || withRedirectTo) {
      const toObject = typeof to === 'string' ? parseUrlLoose(to) : to;

      const search = stringify({
        ...query,
        ...parse(toObject.search || ''),
        ...(withRedirectTo && {
          redirectTo: history.createHref(history.location),
        }),
      });

      history[method]({
        ...toObject,
        search,
      });
    } else {
      history[method](to);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRedirect]);
}

export default function Redirect(props: IProps) {
  useRedirect(props);

  return null;
}
